import styled from '@emotion/styled';
import { StyledProps, Theme } from './Radio.types';
import { space, variant, SpaceProps } from 'styled-system';
import { css } from '@emotion/core';

export const RadioContainer = styled.div<SpaceProps, Theme>`
  display: flex;
  ${(props) => css({ alignItems: props.labelAlignment || 'center' })}
  ${space}
  ${(props) =>
    props.labelPosition &&
    variant({
      prop: 'labelPosition',
      variants: {
        top: {
          flexDirection: 'column-reverse',
        },
        right: {
          flexDirection: 'row',
        },
        bottom: {
          flexDirection: 'column',
        },
        left: { flexDirection: 'row-reverse' },
      },
    })}
`;

export const HiddenRadio = styled.input`
  display: none;
`;

export const RadioLabel = styled.label<SpaceProps, Theme>`
  ${(props) =>
    props.isDisabled &&
    css({
      color: 'var(--color-indigo)',
    })}
`;

export const StyledRadio = styled.div<SpaceProps, Theme>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  line-height: 24px;
  border-radius: 24px;
  background: 'var(--color-extra-white)';
  border: 1px solid;
  border-color: 'var(--color-indigo-t11)';
  ${space}
  ${variant({
    prop: 'mode',
    variants: {
      primary: {
        borderColor: 'var(--color-indigo-t11)',
      },
      secondary: {
        borderColor: 'var(--color-indigo-t11)',
      },
      warning: {
        borderColor: 'var(--color-coral)',
      },
      success: {
        borderColor: 'var(--color-vibrant-blue-t8)',
      },
    },
  })};

  ${(props) =>
    props.isDisabled &&
    variant({
      prop: 'mode',
      variants: {
        primary: {
          bg: 'var(--color-b0)',
          borderColor: 'var(--color-indigo-t3)',
        },
        secondary: {
          bg: 'var(--color-b0)',
          borderColor: 'var(--color-indigo-t3)',
        },
        warning: {
          bg: 'var(--color-b0)',
          borderColor: 'var(--color-indigo-t3)',
        },
        success: {
          bg: 'var(--color-b0)',
          borderColor: 'var(--color-indigo-t3)',
        },
      },
    })}

  ${({ labelAlignment, labelPosition }) =>
    labelAlignment === 'flex-start' &&
    ['right', 'left'].includes(labelPosition) &&
    css({ marginTop: '-1px', marginBottom: 0 })}

    ${({ labelAlignment, labelPosition }) =>
    labelAlignment === 'flex-end' &&
    ['right', 'left'].includes(labelPosition) &&
    css({ marginTop: 0, marginBottom: '-1px' })}
`;

export const StyledMark = styled.span<StyledProps, Theme>`
  display: flex;
  width: 14px;
  height: 14px;
  line-height: 14px;
  border-radius: 14px;
  ${variant({
    prop: 'mode',
    variants: {
      primary: {
        bg: 'var(--color-indigo)',
      },
      secondary: {
        bg: 'var(--color-vibrant-blue)',
      },
      warning: {
        bg: 'var(--color-coral)',
      },
      success: {
        bg: 'var(--color-vibrant-blue-t8)',
      },
    },
  })}
  ${(props) =>
    props.isDisabled &&
    variant({
      prop: 'mode',
      variants: {
        primary: {
          bg: 'var(--color-indigo-t3)',
        },
        secondary: {
          bg: 'var(--color-indigo-t3)',
        },
        warning: {
          bg: 'var(--color-indigo-t3)',
        },
        success: {
          bg: 'var(--color-indigo-t3)',
        },
      },
    })}
`;

export default styled.div<StyledProps, Theme>``;
